var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnooze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Action Items Row/Variant8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5 19.75C12.4833 19.75 13.4042 19.5208 14.2625 19.0625C15.1208 18.6042 15.875 18 16.525 17.25C14.375 17.1167 12.5417 16.3208 11.025 14.8625C9.50833 13.4042 8.75 11.6167 8.75 9.5C8.75 9.21667 8.77083 8.92917 8.8125 8.6375C8.85417 8.34583 8.9 8.05833 8.95 7.775C7.86667 8.375 6.97917 9.175 6.2875 10.175C5.59583 11.175 5.25 12.2833 5.25 13.5C5.25 15.2361 5.85764 16.7118 7.07292 17.9271C8.28819 19.1424 9.76388 19.75 11.5 19.75ZM11.5 21.25C9.35 21.25 7.52083 20.4958 6.0125 18.9875C4.50417 17.4792 3.75 15.65 3.75 13.5C3.75 11.35 4.50417 9.52083 6.0125 8.0125C7.52083 6.50417 9.35 5.75 11.5 5.75C11.0667 6.28333 10.75 6.87083 10.55 7.5125C10.35 8.15417 10.25 8.81667 10.25 9.5C10.25 11.2361 10.8576 12.7118 12.0729 13.9271C13.2882 15.1424 14.7639 15.75 16.5 15.75C16.9333 15.75 17.3667 15.7042 17.8 15.6125C18.2333 15.5208 18.65 15.3833 19.05 15.2C18.65 16.9667 17.7458 18.4167 16.3375 19.55C14.9292 20.6833 13.3167 21.25 11.5 21.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 110",
    d: "M14.5 4.5H19.25L14.5 10.5H19.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnooze);
export default __webpack_public_path__ + "static/media/snooze.31336161abc4cf36d30151e2df3dcade.svg";
export { ForwardRef as ReactComponent };